<template>
  <CardGroups class="_mb-sm-40 _mb-md-60">
    <CardBox>
      <CardHeader>
        <BtnToggle :collapse-target="accordionName" class="-plus">
          <h2 class="heading">撮影時のポイント</h2>
        </BtnToggle>
      </CardHeader>

      <CollapseItem
        :id="accordionName"
        :accordion="accordionName"
        :visible="true"
      >
        <CardBody>
          <div class="row">
            <div class="point-img col-12 col-md-6 _mb-15">
              <p class="txt01 _mb-md-30">
                <img
                  src="@/assets/images/icons/circle-orange.svg"
                  class="img-fluid _mr-md-20"
                  alt=""
                />よい例
              </p>
              <div class="img-box">
                <img
                  src="@/assets/images/en/en008/img01.jpg"
                  class="img-fluid _mr-1"
                  alt=""
                /><img
                  src="@/assets/images/en/en008/img02.jpg"
                  class="img-fluid _ml-1"
                  alt=""
                />
              </div>
              <ListGroup class="-normal">
                <ListItem class="-normal">文字がはっきり読める</ListItem>
                <ListItem class="-normal">書類全体が写っている</ListItem>
              </ListGroup>
            </div>
            <div class="point-img col-12 col-md-6 _mb-15">
              <p class="txt01 _mb-md-30">
                <img
                  src="@/assets/images/icons/close-gray.svg"
                  class="img-fluid _mr-md-20"
                  alt=""
                />悪い例
              </p>
              <div class="img-box">
                <img
                  src="@/assets/images/en/en008/img03.jpg"
                  class="img-fluid _mr-1"
                  alt=""
                /><img
                  src="@/assets/images/en/en008/img04.jpg"
                  class="img-fluid _ml-1"
                  alt=""
                />
              </div>
              <ListGroup class="-normal">
                <ListItem class="-normal">画像がぼやけている</ListItem>
                <ListItem class="-normal">写真が切れている</ListItem>
              </ListGroup>
            </div>
          </div>
          <ListGroup class="-note">
            <ListItem class="-note">画像はイメージになります。</ListItem>
            <ListItem class="-note"
              >画像に不備がある場合、お電話を差し上げることがございます。</ListItem
            >
          </ListGroup>
        </CardBody>
      </CollapseItem>
    </CardBox>
  </CardGroups>
</template>

<script>
import CollapseItem from "@/components/collapse/CollapseItem";
import CardBody from "@/components/card/CardBody";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import BtnToggle from "@/components/button/BtnToggle";

export default {
  name: "IdentityPoint",
  components: {
    BtnToggle,
    CardHeader,
    CardBox,
    CardGroups,
    ListItem,
    ListGroup,
    CardBody,
    CollapseItem,
  },
  props: {
    accordionType: { type: String, default: "" },
  },
  computed: {
    accordionName() {
      let result = "accordion";
      if (this.accordionType) {
        result = result + "_" + this.accordionType;
      } else {
        result = result + "0";
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.point-img {
  width: 100%;
  @include mq-up(md) {
    width: 50%;
  }
  > .heading-three {
    > .heading {
      > .-icon {
        color: #eb5505;
        font-size: 26px;
        font-weight: bold;
      }
    }
  }
  > .img-box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    img {
      width: 50%;
    }
  }
  > .txt01 {
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: bold;
    img {
      width: 20px;
      @include mq-up(md) {
        width: 30px;
      }
    }
  }
}
</style>
